import { ComponentProps } from 'react';
import { Dropdown } from 'antd';

interface IOpDropdown extends ComponentProps<typeof Dropdown> {
  onClick?(): void;
  testId?: string;
}

export const OpDropdown = ({
  children,
  className = '',
  testId = 'op-dropdown',
  ...dropdownProps
}: IOpDropdown) => {
  return (
    <Dropdown
      data-testid={testId}
      className={`op-dropdown ${className}`.trim()}
      {...dropdownProps}
    >
      {children}
    </Dropdown>
  );
};
